/**
 * plugins
 */
class plugins {
    /**
     * 当前框架跳转父类增加选项卡 其他后台需要按需修改
     */
    redirectParent(url, name) {
        //追加iframe
        var isSave = false; //是否存在
        var parentIframe = parent.document.getElementById('content-main');
        if (parentIframe == null) {
            window.location.href = '/' + url;
            return false;
        }
        parentIframe.childNodes.forEach(function (item) {
            if (item.dataset.id == '/' + url) {
                isSave = true;
                item.style.display = 'inline'
            } else {
                item.style.display = 'none'
            }
        })
        if (!isSave) { //如果不存在,就追加iframe元素
            var html = '<iframe class="J_iframe" ' +
                'name="iframe0" width="100%" height="100%" ' +
                'src="/' + url + '" frameborder="0" data-id="/' + url + '" seamless=""></iframe>'
            $('#content-main', parent.document).append(html);
        }
        //追加选项卡
        var istabSave = false;
        //选项卡
        var tab_arr = $('.J_menuTabs .page-tabs-content', parent.document)[0];
        tab_arr.childNodes.forEach(function (item, index) {
            if (item.dataset.id === '/' + url) {
                istabSave = true;
                tab_arr.childNodes[index].classList.add('active')
            } else {
                tab_arr.childNodes[index].classList.remove('active')
            }
        })
        if (!istabSave) { //不存在就追加
            var html = '<a href="javascript:;" ' +
                'class="active J_menuTab" ' +
                'data-id="/' + url + '">' + name + ' <i class="fa fa-times-circle"></i></a>';
            $('.J_menuTabs .page-tabs-content', parent.document).append(html)
        }
    }

    message(message = '错误', type = 'error') {
        type = type == 1 ? 'success' : type;
        const {ElMessage} = parent.ElementPlus || ElementPlus
        ElMessage({
            type: type,
            showClose: true,
            message: message,

        })
    }

    notify(type = '') {
        this.init();
        const {h} = Vue;
        //type-> success/warning/info/error
        //position->top-right/top-left/bottom-right/bottom-left
        this.vm.$notify({
            title: '标题名称',
            type: type,
            message: h('i', {style: 'color:red'}, '你好呀notify')
        });
    }

    dialog(url = '', title = '..', callback, height = 100) {
        this.vm = parent.vm || vm;
        this.vm.dialogShow = true;
        this.vm.dialog.title = title;
        this.vm.dialog.height = height;
        this.vm.dialog.url = url;
        let unwatch = this.vm.$watch('dialogShow', (val, prevVal) => {
            callback(true)
            unwatch();
        })

    }

    post(url, params) {
        return new Promise((resolve, reject) => {
            axios.post(url, params).then(res => {
                resolve(res.data)
            }).catch(e => {
                reject(e)
            })
        })
    }

    closeDialog(time = 2000) {
        this.vm = parent.vm || vm;
        setTimeout(function () {
            this.vm.dialogShow = false;
        }, time);
    }

    get(url = this.url, params) {
        return new Promise((resolve, reject) => {
            axios.get(url, params).then(res => {
                resolve(res.data)
            }).catch(e => {
                reject(e)
            })
        })
    }

    put(url, params) {
        return axios.put(url, params);
    }

    request(url = '', params, method = 'post') {
        const instance = axios.create({
            method: method
        })
        return instance({
            url: url,
            data: params,
        })
    }

    redirect(url) {
        window.location.href = url;
    }

    redirectParent(url, name) {
        //追加iframe
        var isSave = false; //是否存在
        var parentIframe = parent.document.getElementById('content-main');
        if (parentIframe == null) {
            window.location.href = '/' + url;
            return false;
        }
        parentIframe.childNodes.forEach(function (item) {
            if (item.dataset.id == '/' + url) {
                isSave = true;
                item.style.display = 'inline'
            } else {
                item.style.display = 'none'
            }
        })
        if (!isSave) { //如果不存在,就追加iframe元素
            var html = '<iframe class="J_iframe" ' +
                'name="iframe0" width="100%" height="100%" ' +
                'src="/' + url + '" frameborder="0" data-id="/' + url + '" seamless=""></iframe>'
            $('#content-main', parent.document).append(html);
        }
        //追加选项卡
        var istabSave = false;
        //选项卡
        var tab_arr = $('.J_menuTabs .page-tabs-content', parent.document)[0];
        tab_arr.childNodes.forEach(function (item, index) {
            if (item.dataset.id === '/' + url) {
                istabSave = true;
                tab_arr.childNodes[index].classList.add('active')
            } else {
                tab_arr.childNodes[index].classList.remove('active')
            }
        })
        if (!istabSave) { //不存在就追加
            var html = '<a href="javascript:;" ' +
                'class="active J_menuTab" ' +
                'data-id="/' + url + '">' + name + ' <i class="fa fa-times-circle"></i></a>';
            $('.J_menuTabs .page-tabs-content', parent.document).append(html)
        }
    }

    setHeight() {
        let clientHeight = window.document.body.clientHeight;
        let parentDocument = parent.document.getElementById('dialog');
        if (parentDocument != undefined) {
            if (clientHeight < 300) {
                parentDocument.style.height = 300 + 'px';
            } else {
                parent.document.getElementById('dialog').style.height = '500px'
            }
        }

    }

    //初始化
    init() {
        this.vm = parent.vm || vm;
        this.url = window.location.pathname + '/index';
    }

    /**
     * 获取全局变量
     * @param name
     * @returns {*}
     */
    getQueryVariable(name) {
        let result;
        let strUrl = window.location.search.substr(1);
        let arr = strUrl.split('&');
        arr.forEach(item => {
            let newArr = item.split('=');
            if (name == newArr[0]) {
                result = decodeURIComponent( newArr[1]);
            }
        })
        return result;
    }
}

let plugin = new plugins();
/**
 * vue
 */
const mixin = typeof mixin == 'undefined' ? {} : mixin;
const app = Vue.createApp({
    data() {
        return {
            title: '',
            page: {
                current_page: 1,
                count: 0,
                listRows: 15
            },
            tableData: [{
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄',
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄',
            }, {
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }],
            dialogShow: false,
            dialog: {
                outerVisible: false,
                url: '',
                title: '',
                height: 100,
            },
            loading: true,
            message: 'this is a message'
        }
    },
    mixins: [mixin],
    methods: {
        reflash() {
            window.location.reload();
        },
        currentChange(page) {
            this.page.current_page = page;
            this.init();
        }
    },
    mounted() {
        let title = plugin.getQueryVariable('title');
        if (title != undefined) {
            this.title = title
        }
    }
})

app.use(ElementPlus)


const vm = app.mount('.app')





